<script>
    import { NotificationModal } from "../../../Components/Common/index.svelte";

    import { DirectInsuranceType } from "../../../Utils/utilEnums.svelte";

    import {
        getText,
        isObjectEmpty,
        splitCamelCase,
    } from "../../../Utils/utilFunctions.svelte";

    export let opvResult = {},
        isModalOpen = false,
        showAsModal = true,
        closeModal = () => {};

    let properties = [],
        modalTitle = "",
        opvVerificationSuccess = false;

    $: if (isModalOpen || !showAsModal) mapOpvResult(opvResult);
    else properties = [];

    const mapOpvResult = (result) => {
        if (!result || isObjectEmpty(result)) {
            properties = [];
            return;
        }

        modalTitle = result.error
            ? "Verification Failed"
            : result.insuranceType == DirectInsuranceType.DVA
              ? result.veteranStatus == 1
                  ? "Verification Complete"
                  : "Verification Error"
              : result.insuranceType == DirectInsuranceType.Private
                ? result.medicareStatus == 2 || result.healthFundStatus == 2
                    ? "Verification Error"
                    : "Verification Complete"
                : result.medicareStatus == 2
                  ? "Verification Error"
                  : "Verification Complete";

        properties = result.error
            ? [
                  {
                      title: "Error: ",
                      value: result.error,
                      contentClass: "text-red-400",
                  },
              ]
            : [
                  {
                      title: "Medicare: ",
                      value: _getMedicareStatus(result),
                      contentClass: _getMedicareStatus(result, true),
                      isHidden: result.insuranceType == DirectInsuranceType.DVA,
                  },
                  {
                      title: "Medicare Text: ",
                      value: getText(result.medicareText, "-"),
                      isHidden: result.insuranceType == DirectInsuranceType.DVA,
                  },
                  {
                      title: "Health Fund: ",
                      value: _getHealthFundStatus(result),
                      contentClass: _getHealthFundStatus(result, true),
                      isHidden:
                          result.insuranceType != DirectInsuranceType.Private,
                  },
                  {
                      title: "Health Fund Text: ",
                      value: getText(result.healthFundText, "-"),
                      isHidden:
                          result.insuranceType != DirectInsuranceType.Private,
                  },
                  {
                      title: "Veteran Verification: ",
                      value: _getVeteranStatus(result),
                      contentClass: _getVeteranStatus(result, true),
                      isHidden: result.insuranceType != DirectInsuranceType.DVA,
                  },
                  {
                      title: "Veteran Verification Text: ",
                      value: getText(result.veteranText, "-"),
                      isHidden: result.insuranceType != DirectInsuranceType.DVA,
                  },
              ];

        for (const [key, value] of Object.entries(result)) {
            if (/suggested/.test(key) && value) {
                properties.push({
                    title: `${splitCamelCase(key)}: `,
                    value,
                });
            }
        }

        opvVerificationSuccess =
            result.insuranceType == DirectInsuranceType.DVA
                ? result.veteranStatus == 1
                : result.insuranceType == DirectInsuranceType.Private
                  ? result.medicareStatus != 2 && result.healthFundStatus != 2
                  : result.medicareStatus != 2;
    };

    // HELPER FUNCTIONS
    const _getMedicareStatus = (result, isStyle = false) => {
        const { medicareStatus } = result;

        if (isStyle)
            return medicareStatus == 1
                ? "text-greenDefault"
                : medicareStatus == 0
                  ? ""
                  : "text-red-400";

        return medicareStatus == 1
            ? "Success"
            : medicareStatus == 0
              ? "Not Checked"
              : "Failure";
    };

    const _getHealthFundStatus = (result, isStyle = false) => {
        const { healthFundStatus } = result;

        if (isStyle)
            return healthFundStatus == 1
                ? "text-greenDefault"
                : healthFundStatus == 0
                  ? ""
                  : "text-red-400";

        return healthFundStatus == 1
            ? "Success"
            : healthFundStatus == 0
              ? "Not Checked"
              : "Failure";
    };

    const _getVeteranStatus = (result, isStyle = false) => {
        const { veteranStatus } = result;

        if (isStyle)
            return veteranStatus == 1
                ? "text-greenDefault"
                : veteranStatus == 0
                  ? ""
                  : "text-red-400";

        return veteranStatus == 1
            ? "Success"
            : veteranStatus == 0
              ? "Not Checked"
              : "Failure";
    };
</script>

{#if showAsModal && isModalOpen && !!properties.length}
    <NotificationModal
        title={modalTitle}
        {isModalOpen}
        showConfirmBtn={false}
        {closeModal}
        closeModalFunction={closeModal}
        cancelButtonClass="btn-accent"
    >
        <div class="flex flex-col max-h-96">
            <div class="flex flex-col overflow-y-auto gap-y-2">
                {#if opvVerificationSuccess}
                    <div class="flex w-full items-center">
                        Patient verified successfully.
                    </div>
                {:else}
                    {#each properties as property}
                        {#if !property.isHidden}
                            <div class="flex gap-2 w-full items-start">
                                <p class="title">{property.title}</p>

                                <p class={`content ${property.contentClass}`}>
                                    {property.value}
                                </p>
                            </div>
                        {/if}
                    {/each}
                {/if}
            </div>
        </div>
    </NotificationModal>
{/if}

{#if !showAsModal}
    <div class="flex flex-col max-h-96">
        <div class="flex flex-col overflow-y-auto gap-y-2">
            {#if opvVerificationSuccess}
                <div class="flex w-full items-center">
                    Patient verified successfully.
                </div>
            {:else}
                {#each properties as property}
                    {#if !property.isHidden}
                        <div class="flex gap-2 w-full items-start">
                            <p class="title">{property.title}</p>

                            <p class={`content ${property.contentClass}`}>
                                {property.value}
                            </p>
                        </div>
                    {/if}
                {/each}
            {/if}
        </div>
    </div>
{/if}

<style>
    .title {
        width: 33%;
    }

    .content {
        width: 67%;
    }
</style>
